import React from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function EntityRow({ entity, fields, onEdit, onDelete, isSelected, renderField, extraActions }) {
  const rowStyle = isSelected
    ? { backgroundColor: "#f8d7da" }
    : {};

  const idPrefix = `entity-${entity.id}`;

  return (
    <tr style={rowStyle} data-testid="entity-row">
      {fields.map((field, index) => {
        const value = entity[field];
        const cellContent = renderField(field, value);
        return <td key={index} style={{ verticalAlign: "middle" }}>{cellContent}</td>;
      })}

      {(onEdit || onDelete || extraActions) && (
        <td style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.25rem"
            }}
          >
            {onEdit && (
              <>
                <Button
                  id={`${idPrefix}-edit`}
                  aria-label="Edit"
                  color="link"
                  size="sm"
                  onClick={(e) => {
                    e.currentTarget.blur();
                    onEdit(entity);
                  }}
                >
                  <FontAwesomeIcon icon="pencil-alt" style={{ fontSize: "1.2em" }} />
                </Button>
                <UncontrolledTooltip
                  target={`${idPrefix}-edit`}
                  placement="top"
                >
                  Edit
                </UncontrolledTooltip>
              </>
            )}

            {extraActions && extraActions(entity, idPrefix)}

            {onDelete && (
              <>
                <Button
                  id={`${idPrefix}-delete`}
                  size="sm"
                  color="link"
                  aria-label="Delete"
                  onClick={(e) => {
                    e.currentTarget.blur();
                    onDelete(entity);
                  }}
                >
                  <FontAwesomeIcon icon="trash" style={{ fontSize: "1.2em", color: "#fc6a6d" }} />
                </Button>
                <UncontrolledTooltip
                  target={`${idPrefix}-delete`}
                  placement="top"
                >
                  Delete
                </UncontrolledTooltip>
              </>
            )}

          </div>
        </td>
      )}
    </tr>
  );
}


export default EntityRow;